import { render, staticRenderFns } from "./stock_summary_list.vue?vue&type=template&id=413d4738&scoped=true"
import script from "./stock_summary_list.vue?vue&type=script&lang=js"
export * from "./stock_summary_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d4738",
  null
  
)

export default component.exports